export function LogoMark() {
  return (
    <svg viewBox="0 0 48 48" aria-hidden focusable="false">
      <rect x="9" y="31" width="30" height="7.5" rx="2" fill="#fff" />
      <rect x="12.5" y="22" width="24" height="7.5" rx="2" fill="#fff" fillOpacity=".8" />
      <rect x="10.5" y="13" width="27" height="7.5" rx="2" fill="#fff" fillOpacity=".58" />
      <rect x="15" y="31" width="2.4" height="7.5" fill="#2FBF6D" fillOpacity=".32" />
      <rect x="31" y="22" width="2.4" height="7.5" fill="#2FBF6D" fillOpacity=".32" />
      <rect x="33" y="13" width="2.4" height="7.5" fill="#2FBF6D" fillOpacity=".32" />
    </svg>
  );
}
